import { render } from "./LocalizationSelector.vue?vue&type=template&id=3d7efa5d&scoped=true"
import script from "./LocalizationSelector.vue?vue&type=script&lang=js"
export * from "./LocalizationSelector.vue?vue&type=script&lang=js"

import "./LocalizationSelector.vue?vue&type=style&index=0&id=3d7efa5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7efa5d"]])

export default __exports__